// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3LeGV","boxWrapper":"_1ec4x"};